import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6766dc5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "identicons-container" }
const _hoisted_2 = { class: "is-flex identicons-wrapper" }
const _hoisted_3 = { class: "identicons-row" }
const _hoisted_4 = ["src", "data-testid", "onClick"]
const _hoisted_5 = { class: "txt has-text-centered mt-8" }
const _hoisted_6 = { class: "address-box" }
const _hoisted_7 = ["value"]

import makeBlockie from 'ethereum-blockies-base64'
import { onMounted, ref } from 'vue'
import Eth from 'web3-eth'

import { generateSalt } from '@/shared/utils'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { Identicon } from '@/shared/models/Identicon'
import { upGenerateLSP23addressRequest } from '@/shared/models/GenerateLSP23address'
import { calculateProxyUpAddress } from './calculateProxyUpAddress'
import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'

type Emits = {
  (event: 'update:modelValue', identicon: Identicon): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Identicons',
  props: {
    upGenerateLSP23AddressParams: {},
    eth: {},
    controllerAddress: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const properties = __props

const emits = __emit

const generateIdenticons = async (page: number) => {
  const upGenerateLSP23AddressParams = properties.upGenerateLSP23AddressParams
  const identicons = []
  for (let index = 0; index < 4; index++) {
    const salt = generateSalt()

    const address = calculateProxyUpAddress(
      properties.eth,
      salt,
      properties.controllerAddress,
      upGenerateLSP23AddressParams
    )

    identicons.push({
      id: page * 4 + index,
      address,
      icon: makeBlockie(address),
      salt,
    })
  }

  return identicons
}

const identicons = ref<Identicon[]>([])
const selectedIdenticon = ref(0)

const currentPage = ref(1)
const rerollIcon = ref()

onMounted(async () => {
  identicons.value = [...(await generateIdenticons(currentPage.value))]
  selectIdenticon(0)
})

const selectIdenticon = (index: number) => {
  selectedIdenticon.value = index
  emits('update:modelValue', identicons.value[index])
}

const rerollIdenticons = async () => {
  rerollIcon.value?.classList.add('spinner')
  currentPage.value = currentPage.value + 1
  identicons.value = await generateIdenticons(currentPage.value)
  selectIdenticon(selectedIdenticon.value)
  setTimeout(() => {
    rerollIcon.value?.classList.remove('spinner')
  }, 1000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(identicons.value, ({ icon }, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("div", {
                class: _normalizeClass(["selected-identicon-image", selectedIdenticon.value === index ? 'selected' : 'unselected'])
              }, [
                _createElementVNode("img", {
                  src: icon,
                  "data-testid": 'identicon-' + index,
                  class: "identicon-image",
                  onClick: ($event: any) => (selectIdenticon(index))
                }, null, 8 /* PROPS */, _hoisted_4)
              ], 2 /* CLASS */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", {
          ref_key: "rerollIcon",
          ref: rerollIcon,
          "data-testid": "reroll",
          class: "reroll-wrapper",
          onClick: rerollIdenticons
        }, [
          _createVNode(SvgIcon, {
            name: "reroll",
            class: "reroll"
          })
        ], 512 /* NEED_PATCH */)
      ])
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('create_address.happy_with_address')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(ClipboardCopy, {
        value: identicons.value[selectedIdenticon.value]?.address,
        "has-hover-text": false,
        placement: "top",
        locked: "",
        "offset-distance": "5",
        width: "100%"
      }, {
        default: _withCtx(() => [
          _createElementVNode("input", {
            type: "text",
            readonly: "",
            value: identicons.value[selectedIdenticon.value]?.address,
            class: "is-align-items-center address-input mt-1"
          }, null, 8 /* PROPS */, _hoisted_7)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value"])
    ])
  ]))
}
}

})